import ProductCard from '@maison/components/product/ProductCard.vue';
import MixedGridImageItem from '@maison/components/mixedGrid/MixedGridImageItem.vue';
import MixedGridVideoItem from '@maison/components/mixedGrid/MixedGridVideoItem.vue';
import MixedGridPagePushItem from '@maison/components/mixedGrid/MixedGridPagePushItem.vue';
import MixedGridReversoItem from '@maison/components/mixedGrid/MixedGridReversoItem.vue';

export const useMixedGridItems = () => {
  const getComponent = (template) => {
    switch (template) {
      case 'product':
        return ProductCard;
      case 'image-fit':
        return MixedGridImageItem;
      case 'video-item':
        return MixedGridVideoItem;
      case 'push-item':
      case 'push-video-item':
        return MixedGridPagePushItem;
      case 'reverso-filter':
        return MixedGridReversoItem;
    }
  };

  return { getComponent };
};
